<script>
import Layout from '@/views/layouts/main';
import appConfig from '@/app.config';
import LoadingIcon from '@/components/Loading/main.vue';
import Footer from '@/components/Footer/main.vue';
import Multiselect from '@/components/Multiselect/main.vue';
import RequireTabs from '@/views/pages/require/components/RequireTabs.vue';
import ModalAddTab from '@/views/pages/require/components/ModalAddTab.vue';
import ModalPreviewPartner from '@/views/pages/require/components/ModalPreviewPartner.vue';

import { authComputed, masterMethods, campaignMethods } from '@/state/helpers';
import { showMessage } from '@/utils/messages';
import {
    DATA_REQUIRE,
    DATA_REQUIRE_11,
    configHelper,
    LIST_TAB,
    initTabContentDynamic,
    configTabContentDynamic,
    surnameAddressPhoneNumber
} from './constants';
import { onHandleFakeId, getInfoUserLocalStorage, checkPermission } from '@/utils/handlers';
import {
    updateDateSplit,
    processCampaignData,
    initializeCheckObjects,
    formatDataBeforeSave,
    onHandleUniqueNameTab,
    onMapReportingScheduleLine,
    formatDataShortCode,
    isRolePartner,
    isPermissionPartnerEdit,
    checkPlatFomTab,
    checkPlatFomTabLarge,
    checkPlatFomTabSmall,
    checkLItem,
    checkMItem,
    checkSItem,
    updateAnalyticFormUrlOut,
    getPurchaseConditionDetails
} from '@/views/pages/require/handlers';
import { formatDateCommon } from '@/utils/format';

export default {
    page: {
        title: ' パートナー依頼シート',
        meta: [{ name: 'description', content: appConfig.description }]
    },
    components: {
        RequireTabs,
        Layout,
        LoadingIcon,
        Footer,
        Multiselect,
        ModalAddTab,
        ModalPreviewPartner
    },
    data() {
        return {
            configHelper,
            data: DATA_REQUIRE(),
            data11: DATA_REQUIRE_11(),
            checkUpdate: false,
            loading: false,
            isLoadingTab: false,
            checkOrder: false,
            check1: false,
            check2: false,
            check3: false,
            check4: false,
            detailBeginForDocument: {},
            largeItem: [],
            smallItem: [],
            LItem: [],
            MItem: [],
            SItem: [],
            listDataMasterCampaign: [],
            listSheetsPreview: [],
            campaignRequest: null,
            listSheets: this.visibleTabs,
            isRolePartner: isRolePartner(),
            isPermissionPartnerEdit: isPermissionPartnerEdit()
        };
    },
    watch: {
        'data.lottery_campaign_open.period_conditions_postcard.data': function (newName) {
            updateDateSplit(newName, this.data.lottery_campaign_open.period_conditions_postcard, 'data');
        },
        'data.lottery_campaign_close.period_conditions_postcard.data': function (newName) {
            updateDateSplit(newName, this.data.lottery_campaign_close.period_conditions_postcard, 'data');
        },
        'data.lottery_line.purchase_validity_period.data.start_date': function (newName) {
            updateDateSplit(newName, this.data.lottery_line.purchase_validity_period.data, 'start_date');
        },
        'data.lottery_line.purchase_validity_period.data.end_date': function (newName) {
            updateDateSplit(newName, this.data.lottery_line.purchase_validity_period.data, 'end_date');
        },
        'data.lottery_campaign_close.purchase_date.data.start_date': function (newName) {
            updateDateSplit(newName, this.data.lottery_campaign_close.purchase_date.data, 'start_date');
        },
        'data.lottery_campaign_close.purchase_date.data.end_date': function (newName) {
            updateDateSplit(newName, this.data.lottery_campaign_close.purchase_date.data, 'end_date');
        },
        'data.lottery_campaign_open.prizes.data': {
            handler() {
                this.calculateTotals('lottery_campaign_open', 'prizes');
            },
            deep: true
        },
        'data.lottery_campaign_close.prizes.data': {
            handler() {
                this.calculateTotals('lottery_campaign_close', 'prizes');
            },
            deep: true
        },
        'data.lottery_line.prizes.data': {
            handler() {
                this.calculateTotals('lottery_line', 'prizes');
            },
            deep: true
        },
        'data.lottery_twitter.hashtags.data': {
            handler() {
                this.calculateTotals1('lottery_twitter', 'hashtags');
            },
            deep: true
        },
        'data.lottery_twitter.twitter_rt.data': {
            handler() {
                this.calculateTotals2('lottery_twitter', 'twitter_rt');
            },
            deep: true
        },
        'data.lottery_instagram.hashtags.data': {
            handler() {
                this.calculateTotals1('lottery_instagram', 'hashtags');
            },
            deep: true
        },
        visibleTabs: {
            handler(newVisibleTabs) {
                this.listSheets = newVisibleTabs;
            },
            immediate: true,
            deep: true
        }
    },
    async mounted() {
        let { default_campaign } = this.currentUser;
        let campaingDefault = default_campaign;
        const queryIdCampaign = this.$route.query.id;
        await this.getListMasterCampaign();
        if (queryIdCampaign) {
            campaingDefault = this.listDataMasterCampaign.find((item) => item.id == queryIdCampaign) || default_campaign;
        }
        this.data.campaign_id = this.data11.campaign_id = campaingDefault?.id ?? null;
        this.campaignRequest = campaingDefault;
        if (campaingDefault?.id) {
            this.getListMasterCampaignDetail(campaingDefault?.id);
        }
    },
    computed: {
        ...authComputed,
        visibleTabs() {
            return LIST_TAB(this.data).filter((tab) => this.checkTabVisibility(tab.id));
        }
    },
    methods: {
        ...masterMethods,
        ...campaignMethods,
        configTabContentDynamic,
        updateDateSplit,
        checkPermission,

        checkTabVisibility(id) {
            switch (id) {
                case 1:
                    return this.campaignRequest; // Ví dụ: Biến kiểm tra có request hay không
                case 2: // 【通数依頼】はがき (Logic bạn đã cung cấp)
                    return (
                        (this.checkPlatFomTab(['ハガキ']) && this.checkLItem(['応募収集']) && this.checkMItem(['はがき回収'])) ||
                        this.checkPlatFomTab(['店頭'])
                    );
                case 3: // 【通数依頼】WEB
                    return (
                        (this.checkPlatFomTab(['WEB']) && this.checkLItem(['応募収集']) && this.checkMItem(['WEBフォーム'])) ||
                        this.checkPlatFomTab(['アプリ'])
                    );
                case 4: // 【通数依頼】X・Instagram＃
                    return (
                        this.checkPlatFomTab(['X', 'Instagram', 'TikTok', 'Tiktok']) &&
                        this.checkLItem(['応募収集']) &&
                        this.checkMItem(['SNSツール']) &&
                        this.checkSItem(['X', 'Instagram', 'TikTok', 'Tiktok'])
                    );
                case 5: // 【通数依頼】TwitterRT
                    return (
                        this.checkPlatFomTab(['X']) &&
                        !this.checkPlatFomTab(['Instagram']) &&
                        this.checkLItem(['応募収集']) &&
                        this.checkMItem(['SNSツール']) &&
                        this.checkSItem(['X'])
                    );
                case 6: // 【通数依頼】CR
                    return (
                        this.checkPlatFomTab('LINE') && this.checkLItem(['応募収集']) && this.checkMItem(['SNSツール']) && this.checkSItem(['LINE'])
                    );
                case 7: // 【抽選】オープンCP
                    return this.detailBeginForDocument.campaign_type && this.detailBeginForDocument.campaign_type.value == 'オープン';
                case 8: // 【抽選】クローズCP
                    return this.detailBeginForDocument.campaign_type && this.detailBeginForDocument.campaign_type.value == 'クローズ';
                case 9: // 【抽選】X
                    return this.checkPlatFomTab(['X']);
                case 10: // 【抽選】Instagram
                    return this.checkPlatFomTab(['Instagram']);
                case 11: // 【抽選】CR
                    return this.checkPlatFomTab(['LINE']);
                default:
                    return true; // Mặc định ẩn nếu không khớp ID nào
            }
        },

        async getListMasterCampaign() {
            this.loading = true;
            try {
                let query = '';
                if (this.isRolePartner) {
                    query = `?has[partner]=${getInfoUserLocalStorage().partner_id ?? ''}`;
                }
                const data = await this.getAllDocuments(query);
                if (data.code == 200) {
                    this.listDataMasterCampaign = data.data;
                }
            } catch (error) {
                console.error(error);
            } finally {
                this.loading = false;
            }
        },

        calculateTotals(k1, k2) {
            this.data[k1][k2].sum_total_winner = 0;
            if (this.data[k1][k2].data)
                this.data[k1][k2].data.forEach((item) => {
                    item.total_winner = Number.isNaN(parseInt(item.preliminary_winner) + parseInt(item.number_of_win_prize))
                        ? 0
                        : parseInt(item.preliminary_winner) + parseInt(item.number_of_win_prize);
                    this.data[k1][k2].sum_total_winner = parseInt(this.data[k1][k2].sum_total_winner) + parseInt(item.total_winner);
                });
        },
        calculateTotals1(k1, k2) {
            this.data[k1][k2].sum_total_winner = 0;
            if (this.data[k1][k2].data)
                this.data[k1][k2].data.forEach((item) => {
                    item.total_winner = Number.isNaN(parseInt(item.preliminary_winner) + parseInt(item.number_of_win))
                        ? 0
                        : parseInt(item.preliminary_winner) + parseInt(item.number_of_win);
                    this.data[k1][k2].sum_total_winner = parseInt(this.data[k1][k2].sum_total_winner) + parseInt(item.total_winner);
                });
        },
        calculateTotals2(k1, k2) {
            this.data[k1][k2].sum_total_winner = 0;
            if (this.data[k1][k2].data)
                this.data[k1][k2].data.forEach((item) => {
                    item.total_winner = Number.isNaN(parseInt(item.preliminary_winner) + parseInt(item.number_of_win))
                        ? 0
                        : parseInt(item.preliminary_winner) + parseInt(item.number_of_win);
                    this.data[k1][k2].sum_total_winner = parseInt(this.data[k1][k2].sum_total_winner) + parseInt(item.total_winner);
                });
        },
        getListMasterCampaignDetail(idCampaign, typeHandle = null) {
            if (typeHandle === 'select') {
                this.isLoadingTab = true;
            } else {
                this.loading = true;
            }
            this.data = DATA_REQUIRE();
            this.data11 = DATA_REQUIRE_11();
            this.data.campaign_id = this.data11.campaign_id = idCampaign;
            this.getDetailDocuments({ id: idCampaign }).then((data) => {
                if (data && data.code == 200) {
                    this.detailBeginForDocument = data.data;
                    let hashtags = [];
                    const createCheckObj = () => ({ id: '', name: '', change: true });

                    if (this.detailBeginForDocument.event_prizes) {
                        this.detailBeginForDocument.event_prizes.forEach((item) => {
                            // Update item properties
                            item.is_active = true;
                            item.preliminary_winner = 0;
                            item.name = item.title;
                            item.first_check = createCheckObj();
                            item.secondary_check = createCheckObj();
                            item.number_of_win_prize = item.number_of_win_prize || 0;

                            // Add to hashtags
                            hashtags.push({
                                name: item.title,
                                preliminary_winner: 0,
                                number_of_win: item.number_of_win_prize,
                                total_winner: 0,
                                is_active: true,
                                first_check: createCheckObj(),
                                secondary_check: createCheckObj()
                            });
                        });
                    }
                    let sns = [];
                    let large_item = [];
                    let small_item = [];
                    let addressData = [];
                    let reporting_schedule_twitter_rt = [];
                    let winning_conditions = [];
                    let lottery_method = [];

                    let reporting_schedule_postcard = [];
                    let tool_form = [];
                    let large_i = [];
                    let medium_i = [];
                    let small_i = [];
                    if (
                        this.detailBeginForDocument.campaign_master_order_scopes &&
                        Array.isArray(this.detailBeginForDocument.campaign_master_order_scopes)
                    ) {
                        const checks = {
                            checkOrder: false,
                            check1: false,
                            check2: false,
                            check3: false,
                            check4: false
                        };
                        processCampaignData(
                            this.detailBeginForDocument,
                            large_i,
                            medium_i,
                            small_i,
                            large_item,
                            small_item,
                            winning_conditions,
                            reporting_schedule_postcard,
                            reporting_schedule_twitter_rt,
                            lottery_method,
                            addressData,
                            tool_form,
                            this.data,
                            checks
                        );
                        this.checkOrder = checks.checkOrder;
                        this.check1 = checks.check1;
                        this.check2 = checks.check2;
                        this.check3 = checks.check3;
                        this.check4 = checks.check4;
                    }
                    this.largeItem = large_item;
                    this.smallItem = small_item;
                    this.LItem = large_i;
                    this.MItem = medium_i;
                    this.SItem = small_i;
                    let tool = [];
                    this.detailBeginForDocument.campaign_master_order_scope_partner.forEach((item) => {
                        if (item.tool) tool.push(item.tool.tool);
                    });
                    // Common values
                    const eventPrizes = this.detailBeginForDocument.event_prizes;
                    const lotteryMethodText = lottery_method.join('／');
                    const reportingScheduleTwitterText = reporting_schedule_twitter_rt.join('／');
                    const productRelated = this.detailBeginForDocument?.campaign_content_other?.product_related || '';

                    // Information Management
                    this.data.information_management.social_media_account.data = formatDataShortCode(this.detailBeginForDocument.categories);
                    this.data.information_management.cr_supporter.data = formatDataShortCode(this.detailBeginForDocument.categories, ['LINE']);
                    updateAnalyticFormUrlOut(this.data, this.detailBeginForDocument.categories);

                    // Lottery Line
                    this.data.lottery_line.purchase_validity_period.data = this.detailBeginForDocument.receipt_expiration_date_formated;
                    this.data.lottery_line.prizes.data = eventPrizes;
                    this.data.lottery_line.lottery_method.data = lotteryMethodText;
                    this.data.lottery_line.lottery_method.data = lotteryMethodText;
                    this.data.lottery_line.same_household_1.data = [surnameAddressPhoneNumber];
                    this.data.lottery_line.same_person_1.data = [surnameAddressPhoneNumber];
                    this.data.lottery_line.shipping.data = productRelated;

                    // Request Parameter Postcard
                    this.data.request_parameter_postcard.address.data = addressData.join('／');
                    this.data.request_parameter_postcard.reporting_schedule.data =
                        reporting_schedule_postcard.length > 0 ? reporting_schedule_postcard.join('／') : '';
                    this.data.request_parameter_postcard.contents_of_report_expiration_date.data = `※消印有効期限：${formatDateCommon(this.detailBeginForDocument.campaign_end_date, 'everyDay')}日消印有効`;

                    // Request Parameter Twitter/Instagram
                    this.data.request_parameter_twitter_instagram.reporting_schedule.data = reportingScheduleTwitterText;
                    this.data.request_parameter_twitter_instagram.sns.data = sns.join('／');
                    this.data.request_parameter_twitter_instagram.test_application_1.data = formatDataShortCode(
                        this.detailBeginForDocument.categories,
                        ['X', 'Instagram', 'TikTok'],
                        { tab: 'request_parameter_twitter_instagram', key_apply: 'test_application_1' }
                    );
                    this.data.request_parameter_twitter_instagram.test_application_2.data = formatDataShortCode(
                        this.detailBeginForDocument.categories,
                        ['X', 'Instagram', 'TikTok'],
                        { tab: 'request_parameter_twitter_instagram', key_apply: 'test_application_2' }
                    );
                    // Request Parameter Twitter RT
                    this.data.request_parameter_twitter_rt.reporting_schedule.data = reportingScheduleTwitterText;
                    // Request Parameter  通数依頼】CR
                    this.data.request_parameter_line.reporting_schedule.data = onMapReportingScheduleLine(
                        this.detailBeginForDocument.campaign_master_order_scopes
                    );
                    this.data.request_parameter_line.registration_form.data = formatDataShortCode(this.detailBeginForDocument.categories, ['LINE']);

                    // Lottery Campaign Open
                    this.data.lottery_campaign_open.lottery_method.data = lotteryMethodText;
                    this.data.lottery_campaign_open.prizes.data = eventPrizes;
                    this.data.lottery_campaign_open.same_household_1.data = surnameAddressPhoneNumber;
                    this.data.lottery_campaign_open.same_person_1.data = surnameAddressPhoneNumber;
                    this.data.lottery_campaign_open.period_conditions_postcard.data = formatDateCommon(
                        this.detailBeginForDocument.campaign_end_date,
                        'date'
                    );

                    // Lottery Campaign Close
                    this.data.lottery_campaign_close.prizes.data = eventPrizes;
                    this.data.lottery_campaign_close.lottery_method.data = lotteryMethodText;
                    this.data.lottery_campaign_close.same_household_1.data = surnameAddressPhoneNumber;
                    this.data.lottery_campaign_close.same_person_1.data = surnameAddressPhoneNumber;
                    this.data.lottery_campaign_close.shipping.data = productRelated;
                    this.data.lottery_campaign_close.purchase_date.data.start_date = formatDateCommon(
                        this.detailBeginForDocument.receipt_expiration_start_date,
                        'date'
                    );
                    this.data.lottery_campaign_close.purchase_date.data.end_date = formatDateCommon(
                        this.detailBeginForDocument.receipt_expiration_end_date,
                        'date'
                    );
                    this.data.lottery_campaign_close.period_conditions_postcard.data = formatDateCommon(
                        this.detailBeginForDocument.campaign_end_date,
                        'date'
                    );
                    this.data.lottery_campaign_close.purchase_price.data = getPurchaseConditionDetails(this.detailBeginForDocument);
                    this.data.lottery_campaign_close.purchase_store_or_distribution.data =
                        this.detailBeginForDocument?.campaign_content_other?.announcement_site_related || '';
                    // Request Parameter Web
                    this.data.request_parameter_web.registration_form.data = tool_form.join('／');
                    this.data.request_parameter_web.reporting_schedule.data = onMapReportingScheduleLine(
                        this.detailBeginForDocument.campaign_master_order_scopes
                    );

                    // Lottery Twitter
                    this.data.lottery_twitter.hashtags.data = hashtags;
                    this.data.lottery_twitter.lottery_method.data = lotteryMethodText;
                    this.data.lottery_twitter.excluded_accounts.data = `キャンペーン実施公式アカウントを除く\n${formatDataShortCode(this.detailBeginForDocument.categories)}`;
                    // Lottery Instagram
                    this.data.lottery_instagram.hashtags.data = hashtags;
                    this.data.lottery_instagram.lottery_method.data = lotteryMethodText;
                    this.data = JSON.parse(JSON.stringify(this.data));
                    this.getRequest(idCampaign);
                } else {
                    if (typeHandle === 'select') {
                        this.isLoadingTab = false;
                    } else {
                        this.loading = false;
                    }
                }
            });
        },
        getRequest(idCampaign) {
            this.getPartnerRequestSheet({ campaign_id: idCampaign }).then((data) => {
                if (data && data.code == 200) {
                    this.checkUpdate = true;
                    this.data = data.data ? data.data : {};
                    if (this.data) initializeCheckObjects(this.data);
                    this.data = JSON.parse(JSON.stringify(this.data));
                    this.data = this.mergeObjects(this.data11, this.data);
                    updateAnalyticFormUrlOut(this.data, this.detailBeginForDocument.categories);
                } else {
                    this.checkUpdate = false;
                }
                setTimeout(() => {
                    if (this.isRolePartner) {
                        this.listSheets = LIST_TAB(this.data)
                            .filter((tab) => this.checkTabVisibility(tab.id))
                            .filter((item) => item.is_active);
                    }
                    this.isLoadingTab = false;
                    this.loading = false;
                }, 1000);
            });
        },
        mergeObjects(template, data) {
            const result = { ...data };

            for (const key in template) {
                // eslint-disable-next-line no-prototype-builtins
                if (template.hasOwnProperty(key)) {
                    if (typeof template[key] === 'object' && !Array.isArray(template[key])) {
                        // Nếu key là object, gọi đệ quy để merge object con
                        result[key] = this.mergeObjects(template[key], data[key] || {});
                    } else {
                        // Nếu key là giá trị đơn giản, bổ sung nếu thiếu
                        // eslint-disable-next-line no-prototype-builtins
                        if (!data.hasOwnProperty(key) && key != 'change' && key != 'change') {
                            result[key] = template[key];
                        }
                    }
                }
            }

            return result;
        },
        register() {
            if (!isPermissionPartnerEdit) return;
            let objectData = formatDataBeforeSave(this.data, this.listSheets);
            if (this.checkUpdate) {
                this.updatePartnerRequestSheet(objectData).then((data) => {
                    if (data.code == 200) {
                        showMessage(data.code, this.$bvToast, '更新されました。');
                        this.getListMasterCampaignDetail(this.campaignRequest?.id);
                    }
                });
            } else {
                this.partnerRequestSheet(objectData).then((data) => {
                    if (data.code == 200) {
                        this.checkUpdate = true;
                        showMessage(data.code, this.$bvToast, '更新されました。');
                        this.getListMasterCampaignDetail(this.campaignRequest?.id);
                    }
                });
            }
        },
        checkPlatFomTab(label) {
            return checkPlatFomTab(this.detailBeginForDocument.categories, label);
        },
        checkPlatFomTabLarge(label) {
            return checkPlatFomTabLarge(this.largeItem, label);
        },
        checkPlatFomTabSmall(label) {
            return checkPlatFomTabSmall(this.smallItem, label);
        },
        checkLItem(label) {
            return checkLItem(this.LItem, label);
        },
        checkMItem(label) {
            return checkMItem(this.MItem, label);
        },
        checkSItem(label) {
            return checkSItem(this.SItem, label);
        },

        handleSelectCampaign() {
            this.getListMasterCampaignDetail(this.campaignRequest?.id, 'select');
            this.data.campaign_id = this.data11.campaign_id = this.campaignRequest?.id ?? null;
        },

        onHandlePreview() {
            this.listSheetsPreview = this.listSheets.filter((item) => item.is_active);
            this.configHelper.configModalPreviewPartner.model = true;
            this.configHelper.configModalPreviewPartner.indexEditor++;
        },

        onHandleAddTab() {
            this.configHelper.configModalCommon.model = true;
        },
        onHandleDeleteTab(makeId) {
            this.listSheets = this.listSheets.filter((item) => item.make_id !== makeId);
        },
        handleSaveAddTab(evt) {
            if (!onHandleUniqueNameTab(this.listSheets, evt.name_tab)) {
                this.configHelper.configModalCommon.model = true;
                showMessage(400, this.$bvToast, 'Tên tab đã tồn tại.');
                return;
            }
            this.listSheets.push({
                make_id: onHandleFakeId(this.listSheets),
                name: evt.name_tab,
                information_tab: {
                    title_field: evt.title_field,
                    ...initTabContentDynamic()
                },
                is_active: true,
                is_permanent: false
            });
            this.configHelper.configModalCommon.model = false;
        },

        goToPage(url, id) {
            this.$router.push({ path: url, query: { id: id } });
        }
    }
};
</script>

<template>
    <Layout>
        <div v-if="!loading">
            <div class="col-lg-12">
                <div class="card mb-0" style="min-height: 100vh">
                    <div class="card-body box8">
                        <div class="form-group row">
                            <label class="col-sm-2" style="min-width: 308px">キャンペーン名</label>
                            <div class="col-sm-6">
                                <Multiselect
                                    :id="`select-campaignRequest`"
                                    :value.sync="campaignRequest"
                                    :options="listDataMasterCampaign"
                                    :config.sync="configHelper.configSelectCampaign"
                                    @select="handleSelectCampaign"
                                />
                            </div>
                        </div>
                        <div v-if="!isLoadingTab">
                            <template v-if="campaignRequest?.id">
                                <template v-if="isPermissionPartnerEdit || (!isPermissionPartnerEdit && checkUpdate)">
                                    <RequireTabs
                                        :list-sheets="listSheets"
                                        :detail-begin-for-document="detailBeginForDocument"
                                        :config-tab-content-dynamic="configTabContentDynamic"
                                        :current-user="currentUser"
                                        :check1="check1"
                                        :check2="check2"
                                        :check3="check3"
                                        :check4="check4"
                                        :check-order="checkOrder"
                                        :data="data"
                                        @delete-tab="onHandleDeleteTab"
                                        @add-tab="onHandleAddTab"
                                    />
                                    <ModalAddTab :config="configHelper.configModalCommon" @save="handleSaveAddTab" />
                                    <ModalPreviewPartner :config="configHelper.configModalPreviewPartner">
                                        <div class="form-group row">
                                            <label class="col-sm-2" style="min-width: 308px">キャンペーン名</label>
                                            <div class="col-sm-6">
                                                <Multiselect
                                                    :id="`select-campaignRequest`"
                                                    :value.sync="campaignRequest"
                                                    :options="listDataMasterCampaign"
                                                    :config.sync="configHelper.configSelectCampaign"
                                                    :disabled="true"
                                                    @select="handleSelectCampaign"
                                                />
                                            </div>
                                        </div>
                                        <RequireTabs
                                            :list-sheets="listSheetsPreview"
                                            :detail-begin-for-document="detailBeginForDocument"
                                            :config-tab-content-dynamic="configTabContentDynamic"
                                            :current-user="currentUser"
                                            :check1="check1"
                                            :check2="check2"
                                            :check3="check3"
                                            :check4="check4"
                                            :check-order="checkOrder"
                                            :data="data"
                                            :is-preview="true"
                                            @delete-tab="onHandleDeleteTab"
                                            @add-tab="onHandleAddTab"
                                        />
                                    </ModalPreviewPartner>
                                </template>
                                <template v-else>
                                    <div class="text-center d-flex align-items-center justify-content-center" style="min-height: 300px">
                                        <h5>{{ $t('screenRequired.alertNotRegister') }}</h5>
                                    </div>
                                </template>
                            </template>
                        </div>
                        <div v-else>
                            <div class="d-flex justify-content-center">
                                <LoadingIcon />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer>
                <div class="d-flex justify-content-center">
                    <div class="text-center flex-fill box__button--custom">
                        <template v-if="isPermissionPartnerEdit">
                            <button
                                v-if="checkUpdate"
                                type="button"
                                @click="register()"
                                class="btn btn-common btn-success"
                                :disabled="!campaignRequest"
                            >
                                {{ $t('btn.save') }}
                            </button>
                            <button v-else type="button" @click="register()" class="btn btn-common btn-primary" :disabled="!campaignRequest">
                                {{ $t('btn.register') }}
                            </button>
                        </template>
                        <button v-if="!isRolePartner" type="button" class="btn btn-light ml-3" @click="onHandlePreview">
                            <i class="mdi mdi-eye"></i> {{ $t('btn.preview') }}
                        </button>
                        <button
                            v-if="checkPermission('campaign.view') && campaignRequest?.id"
                            type="button"
                            class="btn btn-info ml-3"
                            @click="goToPage('/campaign/form/view', campaignRequest?.id)"
                        >
                            {{ $t('btn.detail') }}
                        </button>
                    </div>
                </div>
            </Footer>
        </div>
        <div v-else>
            <div class="d-flex justify-content-center">
                <LoadingIcon />
            </div>
        </div>
    </Layout>
</template>

<style lang="scss" scoped>
td,
th {
    vertical-align: middle;
}

th[colspan='7'],
th[colspan='8'],
th[colspan='4'] {
    font-size: 20px;
    font-weight: bold;
}

::v-deep {
    .box--text__disabled {
        background-color: #e9ecef;
        padding: 0.47rem 0.75rem;
        border: 1px solid #ced4da;
        border-radius: 0.25rem;
        height: 100%;
        box-sizing: border-box;
        &.disabled_input {
            /* cursor: not-allowed; */
        }
        & .text--not-allowed {
            /* cursor: not-allowed; */
        }
    }
    td:has(> .box--text__disabled) {
        height: 1px;
    }

    .disabled_cursor {
        cursor: default;
    }
    .multiselect.multiselect--disabled .multiselect__tags {
        cursor: default;
    }

    .box-editor.is-disabled {
        cursor: default !important;
    }
}
</style>
